"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTE_IMAGES_PATH = void 0;
exports.NOTE_IMAGES_PATH = "notes/images";
